import React, { useState } from "react";
import { motion } from "framer-motion";

import Skeleton from "react-loading-skeleton";

import { ButtonProps, ButtonTypes, ButtonSizes } from "./Button.types";
import "./Button.scss";

const Button: React.FC<ButtonProps> = ({
  label,
  onClick,
  primary = false,
  disabled = false,
  size = ButtonSizes.small,
  type = ButtonTypes.ok,
  selected,
  loading,
  btnColor,
  labelColor,
}) => {
  const [animate, setAnimate] = useState("init");

  return (
    <motion.div className="mp-atoms-button--main">
      {loading ? (
        <Skeleton className={`skeleton ${size}`} />
      ) : (
        <motion.button
          className={`${type ? type : ""} ${primary ? "primary" : ""} ${size} ${
            selected ? "selected" : ""
          }`}
          style={
            primary
              ? {
                  backgroundColor: btnColor,
                  border: "solid 2px" + btnColor,
                  color: labelColor,
                }
              : {
                  border: "solid 2px" + btnColor,
                  color: btnColor,
                }
          }
          onClick={onClick}
          animate={animate}
          onMouseDown={() => setAnimate("down")}
          onMouseUp={() => setAnimate("up")}
          onTouchStart={() => setAnimate("down")}
          onTouchEnd={() => setAnimate("up")}
          variants={{
            init: { scale: 1.0 },
            down: { scale: 0.95 },
            up: { scale: 1.0 },
          }}
          disabled={disabled}
        >
          {label}
        </motion.button>
      )}
    </motion.div>
  );
};

export default Button;
